import React from 'react'
import { Box, Container } from '@mui/material'
import QuestionSetContainer from './QuestionSetContainer'
/**
 * 
 
questions={quizState.Questions}
authtoken={currentUser.AuthToken}
responseguid={quizState.ResponseGuid}
startfromBeginning={quizState.StartFromBeginning}
uom={quizState.UnitOfMeasure}
validationMessages={ValidationMessages}
questionPrompts={QuestionPrompts}
updateQuestionTotal={updateQuestionTotal}
updateQuestionsAnswered={updateQuestionsAnswered}
setCurrentIndex={setCurrentIndex} 
completeSuccessful={completeSuccessful}/>
*/



const HRAContainer=(props)=>{

    
    return (
        <Container maxWidth='sm'>
                <Box p={1} sx={{ paddingLeft: {m: '25%', xs: "0%"}, paddingRight: {m: '25%', xs: "0%"}}}>
                    <QuestionSetContainer responseGuid={props.responseGuid}/>
                </Box>
        </Container>
        
    )

}

export default HRAContainer